import { roomConfigurationDetails, roomTypes } from '../constants/roomConstants'
import _ from 'lodash'

export const roomConfig = {
  [roomTypes.lodge]: {
    isAdultRequired: false,
    minAge: 7
  },
  [roomTypes.studio]: {
    isAdultRequired: true,
    minAge: 0
  },
  [roomTypes.queenSuite]: {
    isAdultRequired: true,
    minAge: 14
  },
  [roomTypes.kingSuite]: {
    isAdultRequired: true,
    minAge: 14
  },
  [roomTypes.mahimaStay]: {
    isAdultRequired: false,
    minAge: 7
  },
  [roomTypes.cabin]: {
    isAdultRequired: false,
    minAge: 18
  }
}

export function isAdultRequired(roomType) {
  return roomConfig[roomType].isAdultRequired
}

export function isChildAllowed(roomType) {
  return roomConfig[roomType].minAge < 7
}

export function isYoungAdultAllowed(roomType) {
  return roomConfig[roomType].minAge < 14
}

export function isNewStudioType(roomType) {
  return roomType === roomTypes.studio
}

function areGuestsLessThanMax(maxGuests, bookedAdults, bookedChildren) {
  return _.some(
    maxGuests,
    ({ adults, children }) =>
      bookedAdults <= adults && bookedChildren <= children
  )
}

function areGuestsMoreThanMin(minGuests, totalGuests) {
  return minGuests === undefined || totalGuests >= minGuests
}

export function canBookRoomConfiguration(
  configuration,
  numAdults,
  numChildren
) {
  if (!configuration) return true

  let { minGuests, maxGuests } = roomConfigurationDetails[configuration]
  let totalGuests = numAdults + numChildren

  const minLimitOk = areGuestsMoreThanMin(minGuests, totalGuests)
  const maxLimitOk = areGuestsLessThanMax(maxGuests, numAdults, numChildren)

  const canBook = minLimitOk && maxLimitOk
  const reason = canBook
    ? null
    : !minLimitOk
    ? `This room requires minimum ${minGuests} guests`
    : `Number of guests exceeds room capacity`
  const reasonCode = canBook ? null : !minLimitOk ? 'min' : 'max'

  return {
    canBook,
    reason,
    reasonCode
  }
}

export function getRoomConfigurationSortOrder(roomConfiguration) {
  return roomConfigurationDetails[roomConfiguration].order
}

export function getRoomConfigurationDisplayName(roomConfiguration) {
  return roomConfigurationDetails[roomConfiguration].displayName
}



// WEBPACK FOOTER //
// ./src/logic/roomLogic.js